export const withHttp = (url: string) =>
  !/^https?:\/\//i.test(url) ? `https://${url}` : url;
